import React from 'react';
import { Row, Col, Card, Typography, Spin, Alert } from 'antd';
import { useCourseList } from '../hooks/course';
import { useResponsive } from '../hooks/useResponsive';
import { useSecurityProtection } from '../hooks/useSecurityProtection';

const { Title, Text } = Typography;

const Courses: React.FC = () => {
  const { isMobile } = useResponsive();
  useSecurityProtection();
  const { data: courses, isLoading, error } = useCourseList();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px' 
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error"
        description="Failed to load courses. Please try again later."
        type="error"
        showIcon
      />
    );
  }

  return (
    <div style={{ padding: isMobile ? '12px' : '24px' }}>
      <Title level={3} style={{ marginBottom: isMobile ? '16px' : '24px', fontSize: isMobile ? '20px' : '24px' }}>
        All Courses
      </Title>
      
      <Row gutter={[isMobile ? 12 : 16, isMobile ? 12 : 16]}>
        {courses?.map((course: any, index: number) => (
          <Col xs={24} sm={12} lg={8} xl={6} key={course.id || index}>
            <Card
              hoverable
              style={{
                height: '100%',
                borderRadius: isMobile ? '8px' : '12px',
                overflow: 'hidden'
              }}
              bodyStyle={{ padding: isMobile ? '12px' : '24px' }}
              cover={
                course.thumbnail_url && (
                  <img
                    alt={course.title}
                    src={course.thumbnail_url}
                    style={{ height: isMobile ? 160 : 200, objectFit: 'cover', width: '100%' }}
                  />
                )
              }
            >
              <Card.Meta
                title={
                  <Title level={4} style={{ margin: 0, fontSize: isMobile ? '16px' : '18px' }}>
                    {course.title || 'Untitled Course'}
                  </Title>
                }
                description={
                  <div>
                    <Text 
                      style={{ 
                        fontSize: isMobile ? '12px' : '14px',
                        color: '#666',
                        display: 'block',
                        marginBottom: '8px'
                      }}
                    >
                      {course.description || 'No description available'}
                    </Text>
                    
                    {course.difficulty && (
                      <Text 
                        style={{ 
                          fontSize: isMobile ? '11px' : '12px',
                          color: '#1890ff',
                          fontWeight: 'bold'
                        }}
                      >
                        Level: {course.difficulty}
                      </Text>
                    )}
                    
                    {course.duration_weeks && (
                      <Text 
                        style={{ 
                          fontSize: isMobile ? '11px' : '12px',
                          color: '#666',
                          display: 'block',
                          marginTop: '4px'
                        }}
                      >
                        Duration: {course.duration_weeks} weeks
                      </Text>
                    )}
                    
                    {course.instructor && (
                      <Text 
                        style={{ 
                          fontSize: isMobile ? '11px' : '12px',
                          color: '#666',
                          display: 'block',
                          marginTop: '4px'
                        }}
                      >
                        Instructor: {typeof course.instructor === 'string' 
                          ? course.instructor 
                          : course.instructor.first_name || course.instructor.username || 'Unknown'}
                      </Text>
                    )}
                  </div>
                }
              />
            </Card>
          </Col>
        ))}
      </Row>

      {!courses || courses.length === 0 ? (
        <Card style={{ textAlign: 'center', padding: '48px 24px', marginTop: '24px' }}>
          <Text type="secondary" style={{ fontSize: '16px' }}>
            No courses available
          </Text>
        </Card>
      ) : null}
    </div>
  );
};

export default Courses;
